module.exports = __webpack_public_path__ + "img/chart_more.c901650f.svg";